import { render, staticRenderFns } from "./fullDocumentShow.vue?vue&type=template&id=33937c6b&scoped=true"
import script from "./fullDocumentShow.vue?vue&type=script&lang=js"
export * from "./fullDocumentShow.vue?vue&type=script&lang=js"
import style0 from "./fullDocumentShow.vue?vue&type=style&index=0&id=33937c6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33937c6b",
  null
  
)

export default component.exports